import CalendarApp from "../../Components/DiaryCalendar/DiaryCalendar";

const DiaryPage = () => {
  return <CalendarApp />;
};

export default DiaryPage;
